import { AppRoute } from '@agentselly/immodossier-shared';
import { WrapperWidget } from '@agentselly/ui';
import { EmptyState } from '~/components/empty/EmptyState';
import { Button } from '~/components/ui/Button';
import { useTranslate } from '@tolgee/react';

export function ForbiddenWidget() {
  const { t } = useTranslate();

  return (
    <WrapperWidget>
      <EmptyState
        title={t('error_forbidden_title')}
        description={t('error_forbidden')}
        actions={
          <a href={AppRoute.ROOT}>
            <Button showArrow>{t('error_forbidden_link')}</Button>
          </a>
        }
      />
    </WrapperWidget>
  );
}
